const state = {
  messages: [],
  notifications: []
}

const getters = {
  getAllMessages: function (state) {
    return state.messages;
  },
  getAllNotifications: function () {
    return state.notifications;
  },
  getRecentNotifications: function () {
    return state.notifications.slice(0, 10);
  }
}

const mutations = {
  UPDATE_MESSAGES (state, {type, messages}) {
    if (Array.isArray(messages)) {
      if (messages.length) {
        messages = messages.map((message) => {
          if (typeof message === 'object') {
            message = message.message;
          }
          return {message: message, type: type};
        });
      }
      state.messages = messages;
    } else {
      state.messages = [{message: messages, type: type}];
    }
  },
  PREPEND_NOTIFICATION (state, {type, message}) {
    state.notifications.unshift({type: type, message: message});
  }
}

const actions = {
  setErrorMessages ({commit}, messages) {
    commit('UPDATE_MESSAGES', {type: 'errors', messages: messages})
  },
  setSuccessMessages ({commit}, messages) {
    console.log('success message!!', messages)
    commit('UPDATE_MESSAGES', {type: 'success', messages: messages})
  },
  setInfoMessages ({commit}, messages) {
    commit('UPDATE_MESSAGES', {type: 'info', messages: messages})
  },
  resetErrors ({dispatch}) {
    dispatch('resetAllMessages', [])
  },
  resetAllMessages ({dispatch}) {
    dispatch('setErrorMessages', [])
    dispatch('setSuccessMessages', [])
    dispatch('setInfoMessages', [])
  },
  addErrorNotification ({commit}, message) {
    commit('PREPEND_NOTIFICATION', {type: 'danger', message: message})
  },
  addSuccessNotification ({commit}, message) {
    console.log('success message!', message)
    commit('PREPEND_NOTIFICATION', {type: 'success', message: message})
  },
  addInfoNotification ({commit}, message) {
    commit('PREPEND_NOTIFICATION', {type: 'info', message: message})
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/errors.js